import Banner from '@/components/banner'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/legal')({
  component: RouteComponent,
})

const legalDocs = [
  {
    name: 'Critical Information Summaries',
    url: '/pdf/critical-information-summary-nbn.pdf',
    external: true,
  },
  {
    name: 'Standard Form of Agreement',
    url: '/pdf/standard-form-of-agreement.pdf',
    external: true,
  },
  {
    name: 'nbn™ Service Description',
    url: '/pdf/nbn-service-description.pdf',
    external: true,
  },
  {
    name: 'nbn™ Key Facts Sheet',
    url: '/pdf/nbn-key-facts-sheet.pdf',
    external: true,
  },
  {
    name: 'Pricing Schedule',
    url: '/pdf/pricing-schedule.pdf',
    external: true,
  },
  {
    name: 'Financial Hardship Policy',
    url: '/pdf/financial-hardship-policy.pdf',
    external: true,
  },
  {
    name: 'Privacy Policy',
    url: 'https://localityenergy.com.au/privacy-policy/',
    external: true,
  },
  {
    name: 'Appointment of Authorised Representative',
    url: '/pdf/appointment-of-authorised-representative.pdf',
    external: true,
  },
  {
    name: `${WHOLESALERNAME} Consumer Awareness`,
    url: '/pdf/Consumer-Awareness-Scams.pdf',
    external: true,
  },
  {
    name: 'Communication of Major Outages',
    url: '/pdf/communication-of-major-outages.pdf',
    external: true,
  },
  {
    name: 'Telecommunications Direct Debit Terms',
    url: '/pdf/telecommunications-direct-debit-terms.pdf',
    external: true,
  },
]

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/legal.jpg"
        containerStyle=" min-h-[450px] lg:min-h-[550px]"
      />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15 px-4 md:px-0">
          Legal
        </h1>

        <div className="card">
          <p className=" text-2xl mb-5">
            Below are the relevant legal documents associated with the{' '}
            {WHOLESALERNAME} service offering.
          </p>
          <ul className="list-none columns-1 md:columns-2 space-y-2">
            {legalDocs.map((doc, i) => (
              <li key={i} className="break-inside-avoid ml-2 text-base">
                <Link
                  to={doc.url}
                  {...(doc.external && {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  })}
                >
                  {doc.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
